import React from "react";
import { formatMomentDate } from "../../../utils/dateHelper";
import CustomTable from "../../../components/table/CustomTable";

const BulkOfferRequestTableSection = ({
    data,
    isLoading,
    isInitialLoad,
    onView,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    totalItems,
    actionList
}) => {
    const pagination = {
        currentPage,
        totalPages: Math.ceil((totalItems || 0) / (pageSize || 10)),
        total: totalItems || 0,
        onPageChange: (page) => setCurrentPage(page),
        pageSize: pageSize || 10,
        setPageSize,
        setCurrentPage,
        perPageOptions: [10, 20, 50, 100],
    };

    const columns = [
        {
            id: "company",
            header: "COMPANY",
            cell: (_, row) => {
                const company = row?.company || {};
                const companyLogo = company?.profile?.logo?.url;
                return (
                    <div className="d-flex align-items-center gap-2">
                        {companyLogo ? (
                            <img src={companyLogo} alt="Logo" width={30} height={30} className="rounded-circle object-fit-cover" />
                        ) : (
                            <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: 30, height: 30, fontSize: 10 }}>Logo</div>
                        )}
                        <div className="d-flex flex-column text-start">
                            <span className="fw-medium text-nowrap">{company.name || "-"}</span>
                            <span className="text-secondary small">{company?.profile?.mobile_number || "-"}</span>
                        </div>
                    </div>
                );
            }
        },
        {
            id: "company_owner",
            header: "COMPANY OWNER",
            cell: (_, row) => {
                const company = row?.company || {};
                const creator = company?.creator || {};
                const profilePhoto = creator?.profile?.profile_photo?.url;
                const fullName = `${creator.first_name || ""} ${creator.last_name || ""}`.trim();
                return (
                    <div className="d-flex align-items-center gap-2">
                        {profilePhoto ? (
                            <img src={profilePhoto} alt="User" width={30} height={30} className="rounded-circle object-fit-cover" />
                        ) : (
                            <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: 30, height: 30, fontSize: 10 }}>
                                {creator.first_name ? creator.first_name[0] : "U"}
                            </div>
                        )}
                        <div className="d-flex flex-column text-start">
                            <span className="fw-medium text-nowrap">{fullName || "-"}</span>
                            <span className="text-secondary small">{creator.mobile_number || "-"}</span>
                        </div>
                    </div>
                );
            }
        },
        {
            id: "description",
            header: "DESCRIPTION",
            cell: (_, row) => {
                const desc = row?.description || "";
                return (
                    <span className="small text-nowrap text-start" title={desc}>
                        {desc.length > 50 ? `${desc.substring(0, 50)}...` : desc || "-"}
                    </span>
                );
            }
        },
        {
            id: "requested_on",
            header: "REQUESTED ON",
            cell: (_, row) => (
                <span className="small text-nowrap">
                    {row?.created_at ? formatMomentDate(row.created_at, "DD MMM YYYY") : "-"}
                </span>
            )
        }
    ];

    return (
        <CustomTable
            data={data || []}
            columns={columns}
            loading={isLoading && !isInitialLoad}
            emptyMessage="No bulk offer requests found"
            keyField="id"
            pagination={pagination}
            actionList={actionList}
            rowClick={(row) => onView && onView(row)}
        />
    );
};

export default BulkOfferRequestTableSection;
